

const applicationReducer = (state = {}, action) => {
    switch (action.type) {
        case "APPLICATION_LOADED_SUCCESS":
            console.log(action.data);

            return Object.assign({}, state, {
                getapplication: action.data,
            });
        case "APPLICATION_LICENSE_LOADED_SUCCESS":
            return Object.assign({}, state, {
                getApplicationLicenseStatus: action.data,
            });
        case "APPLICATION_USERS_LOADED_SUCCESS":
            return Object.assign({}, state, {
                getApplicationUsers: action.data,
            });
        case "APPLICATION_PURCHASE_LICENSE_LOADED_SUCCESS":
            return Object.assign({}, state, {
                purchaseLicense: action.data,
            });
        case "ROLE_USER_ADDED_SUCCESS":
            return Object.assign({}, state, {
                mapUser: action.data,
            });
        case "ROLE_USER_DELETED_SUCCESS":
            return Object.assign({}, state, {
                deleteMappedUser: action.data,
            });
        case "AUDIT_SUCCESS":
            return Object.assign({}, state, {
                auditLog: action.data,
            });
        case "TABLE_LOADER":
            return Object.assign({}, state, {
                userRoleAssign: action.data,
            });

        default:
            return state;
    }
};

export default applicationReducer;